<!-- 音像 -->

<template>
    <div class="ssTabList">
         <div class="rejects" v-if="opMsg">
              <div class="rejLine">
                  <div class="rejName">状态：</div>
                  <div class="rejText">退回</div>
              </div>
              <div class="rejLine">
                  <div class="rejName">原因：</div>
                  <div class="rejText">{{ opMsg }}</div>
              </div>
         </div>

         <div class="headBar">
             <span>中华XXXXXXX杂志（电子版）</span>
             <el-button size="small">打印</el-button>
         </div>

         <div class="tabArea">
           <table class="tabElement" >
               <tr class="tabHead">
                    <td>序号</td>
                    <td>连续型电子出版物出版情况登记表</td>

                    <td>查阅时间</td>
                    <td colspan="2">操作</td>
               </tr>
               <tr v-for="(term,inx) in tabDat">
                    <td>{{ inx + 1 }}</td>
                    <td>{{ term.name }}</td>
                    <td>{{ term.updatedAt | translate('time') }}</td>
                    <td>
                        <el-button @click="toEdit(term)" size="mini">查看</el-button>
                    </td>
                    <td v-if="inx == 0" rowspan="3">
                        <a :href="printUrl" v-if="term.code == '401'"><el-button size="mini" @click="print(term)">导出打印表</el-button></a>
                        <a :href="printUrl1" v-else-if="term.code == '404'"><el-button size="mini" @click="print(term)">导出打印表</el-button></a>
                    </td>
                    <td v-else-if="inx == 3">
                        <a :href="printUrl" v-if="term.code == '401'"><el-button size="mini" @click="print(term)">导出打印表</el-button></a>
                        <a :href="printUrl1" v-else-if="term.code == '404'"><el-button size="mini" @click="print(term)">导出打印表</el-button></a>
                    </td>
               </tr>


           </table>

             <!-- <el-table :data="tabDat" border style="width: 100%">
                <el-table-column label="序号" width="60" align="center" type="index">
                </el-table-column>
                <el-table-column prop="name" label="材料名称" align="center"></el-table-column>
                <el-table-column label="完成进度" align="center">
                     <template slot-scope="scope">
                          {{ scope.row.status | translate('pgress') }}
                     </template>
                </el-table-column>
                <el-table-column label="更新时间" align="center">
                     <template slot-scope="scope">
                          {{ scope.row.updatedAt | translate('time') }}
                     </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                     <template slot-scope="scope">
                           <el-button v-if="scope.row.status == 8" @click="toEdit(scope.row,1)" type="primary" size="mini">填表</el-button>
                           <el-button v-else @click="toEdit(scope.row,2)" type="danger" size="mini">修改</el-button>
                     </template>
                </el-table-column>
             </el-table> -->

         </div>

         <div class="subArea">
              <el-button @click="goBack" size="small">返回</el-button>
         </div>

    </div>
</template>

<script>
    import { getSuccessTabs } from '@/api/pressRole/pressSuccessive';

    export default{
         props:['pressType'],
         data(){
             return{
                 tabDat:[],
                 zeroStoreage:{
                    id:'',
                    publishMaterialId:'',
                    publishId:'',
                    fileId:'',

                    wSat:0
                 },
                 opMsg:''
             }
         },
         filters:{
             translate:function(dat,code){
                  if(code == 'pgress'){
                      if(dat == 8){
                          return '未提交';
                      }else if(dat == 2){
                          return '已提交';
                      }
                  }else if(code == 'time'){
                      return dat.substr(0,16);
                  }
             }
         },
         methods:{
             toEdit:function(row,type){
                 let urlMap = {
                    401:'edit_ssTab1',
                    402:'edit_ssTab2',
                    404:'edit_ssTab3',
                    410:'sstab4_list'
                 };

                 this.$router.push({
                     path:urlMap[row.code],
                     query:{
                        pressId:row.organizationId,
                        mtId:row.id,
                        pgress:type,
                        listId:this.$route.query.listId
                     }
                 });

             },

             zeroStoreCtrls:function(dat){
                let detAble = this.zeroStoreage.fileId;
                this.zeroStoreage.fileId = dat;
                sUpdate0({pfile1:this.zeroStoreage}).then(response => {
                    if(detAble){
                        detFile({id:detAble}).then(inresp => {
                             this.zeroStoreage.id = response.pfile1.id;
                        })
                    }
                }).catch(error => {})
             },

             pressInit:function(){
                 getSuccessTabs({
                    publishMaterialId:this.$route.query.listId,
                    no:1,
                    size:15
                }).then(response => {
                     this.tabDat = response.ppublicationOrganizationMaterialList;
                })
             },

             goBack:function(){
                 this.$router.go(-1);
                 // this.$router.push({
                 //     path:'successive_press'
                 // })
             }
         },
         created:function(){
             this.pressInit();
         }
    }

</script>

<style lang="scss" scoped type="text/css">
    .ssTabList{
        padding:9px;
        font-size: 14px;
        letter-spacing: 0.72px;

        .rejects{
            border: 1px solid red;
            color: red;
            padding: 15px 0px;
            border-radius: 3px;

            .rejLine{
                position: relative;
                line-height: 20px;

                .rejName{
                    width: 70px;
                    text-align: right;
                    float: left;
                }

                .rejText{
                    margin-left: 65px;
                }
            }
        }

        .headBar{
            padding: 0px 24px;
            height: 45px;
            line-height: 45px;
            background: #F8F8F8;
            color: #666666;

            .el-button{
                float:right;
                margin-top:7px;
                width:90px;
            }
        }

        .tabArea{
            margin-top: 12px;
            padding-bottom: 24px;

            .tabElement{
              width: 100%;
               .tabHead{

                    font-size: 14px;
                    font-weight: bold;
                    td{
                         // background: #f5f7fa;
                         padding: 15px 20px;
                         color: #909399;
                    }
               }
               td{
                    border-collapse: collapse;
                    border: 1px solid #ebeef5;
                    text-align: center;
                    padding: 12px;
                    color: #606266;
               }
            }
        }

        .tabTips{
            font-size: 12px;
            color: #999999;
            margin-top: 9px;

            .tipLine{
                padding-left: 20px;
                position: relative;

                .fsDot{
                    width: 45px;
                    position: absolute;
                    left: 0px;
                }
            }
        }

        .subBar{
            padding: 0px 24px;
            height: 45px;
            line-height: 45px;
            background: #F8F8F8;
            margin-top:6px;
            color: #666666;
        }

        .subArea{
          text-align: center;
          margin-top: 30px;
          margin-bottom: 50px;

          .el-button{
            width: 150px;
          }

        }

        .succedTips{
            font-size:14px;
            color:#666666;
            padding:20px;

            a{
                color:#409EFF;
            }
        }

        .dvsWait{
            text-align:center;
            line-height:240px;
            font-size:24px;
            color:#999999;
        }

    }

</style>



// WEBPACK FOOTER //
// CommonsSive.vue?225c1244